import React, { useRef } from "react";
import VehicleOverview, {
	VehicleOverviewProps
} from "../vehicle-overview/VehicleOverview";
// keep SetupsList, needed for setups
// import SetupsList, { SetuplListProps } from '../setups/SetupsList';
// import { Setup } from '../setups/SetupsList';
import { connect } from "react-redux";
import { DialogTypes } from "../../enums/dialogTypes";
import Navigation from "../navigation/Navigation";
import Grid from "@material-ui/core/Grid";
import { RouteComponentProps, Route } from "react-router-dom";
import {
	mapDispatchToProps,
	mapStateToProps,
	StateManagementProps
} from "../../utils/addReduxProps";
import Categories from "../categories/CategoryList";
import Parts from "../parts/PartsList";
import { withNamespaces, WithNamespaces } from "react-i18next";
// do not remove next line needed for setups
// import PartDetailDialog, { PartDetailDialogProps } from '../parts/PartDetailDialog';
import { Location } from "history";
// do not remove next line, needed for setups
// import { getSetupParts } from '../../utils/helpers';
import ConfigurationSummary from "./ConfigurationSummary";
import {
	ShowDialogProps,
	setCategoryScrollPosition
} from "../../redux/actions";
import { useEffect } from "react";
import http from "../../services/http";
import { AxiosResponse } from "axios";
import { store } from "../../redux/store";
import { getCategoryScrollPosition } from "../../redux/selectors";

export interface CreateConfigurationResponse {
	ConfigurationId: number;
	FullImages: FullImage[];
}

export interface FullImage {
	Perspective: number;
	Url: string;
}

export type ConfigurationAllProps = StateManagementProps &
	WithNamespaces &
	RouteComponentProps<{ modelId: string }>;

export const Configuration: React.FunctionComponent<
	ConfigurationAllProps
> = props => {
	const {
		match: {
			path,
			params: { modelId }
		},
		configuration,
		addCreatedConfiguration,
		views,
		categories
	} = props;

	const scrollElement = useRef<HTMLDivElement>(null);
	const navigationProps = createNavigationProps(props);
	// keep the next line for setups
	// const setuplistProps = createSetupProps(props);
	const configurationExists = configuration.hasOwnProperty("ConfigurationId");

	const categoryProps = {
		categories,
		setScrollPosition: () => {
			if (scrollElement.current) {
				const position = scrollElement.current.scrollTop;
				store.dispatch(setCategoryScrollPosition(position));
			}
		}
	};

	useEffect(() => {
		if (!configurationExists) {
			http
				.createConfiguration(modelId)
				.then((response: AxiosResponse<CreateConfigurationResponse>) => {
					addCreatedConfiguration(response.data);
				});
		}
		if (scrollElement.current) {
			const position = getCategoryScrollPosition(store.getState());
			console.log(`scrolling to position at: ${position}`);
			scrollElement.current!.scrollTo({
				top: position,
				behavior: "smooth"
			});
		}
	}, [modelId, addCreatedConfiguration, configurationExists, scrollElement]);

	return (
		<Grid container spacing={0} className="full-height">
			<Grid item xs={12}>
				<Navigation {...navigationProps} />
			</Grid>
			<Grid item xs={9} className="fit-screen relative">
				<div className="absolute full-width full-height">
					{createVehicleOverview(props.location, configurationExists)}
				</div>
				{views.showConfigurationSummary && (
					<div className="absolute full-width full-height">
						{views.showConfigurationSummary && createSummary(props)}
					</div>
				)}
			</Grid>
			<Grid item xs={3} className="fit-screen">
				<div
					ref={scrollElement}
					id="categories-scrollable-wrapper"
					className="overflow-auto full-height"
				>
					{/* TEMPORARILY HIDE SETUPS PATH */}
					{/* <Route path={path} exact render={(props: RouteComponentProps) => {
                    return <SetupsList {...setuplistProps} {...props}></SetupsList>
                }}>
                </Route> */}
					<Route
						exact
						path={path + "/categories"}
						component={(routerProps: RouteComponentProps<any>) => {
							return <Categories {...categoryProps} {...routerProps} />;
						}}
					></Route>
					<Route
						exact
						path={path + "/categories/:categoryId"}
						component={(props: RouteComponentProps<any>) => {
							return <Parts {...props} />;
						}}
					></Route>
				</div>
			</Grid>
		</Grid>
	);
};

export default withNamespaces()(
	connect(
		mapStateToProps,
		mapDispatchToProps
	)(Configuration)
);

function createSummary(props: ConfigurationAllProps): React.ReactNode {
	return <ConfigurationSummary {...props} />;
}

function createVehicleOverview(
	location: Location<any>,
	configurationExists: boolean
): React.ReactNode {
	// make sure not to render anything before configuration becomes available
	if (!configurationExists) {
		return null;
	}

	let vehicleOverviewProps: VehicleOverviewProps = { location };

	return <VehicleOverview {...vehicleOverviewProps}></VehicleOverview>;
}

function createNavigationProps({ showDialog, t }: ConfigurationAllProps) {
	// last warning before reset
	const warnBeforeExit = () => {
		const dialogProps: ShowDialogProps = {
			title: t("dialogs.warnBeforeExit.title"),
			data: t("dialogs.warnBeforeExit.text"),
			contentType: DialogTypes.warnBeforeExit
		};
		showDialog(dialogProps);
	};

	// open save configuration dialog
	const saveConfiguration = () => {
		const dialogProps: ShowDialogProps = {
			title: t("dialogs.saveConfiguration.title"),
			data: {},
			contentType: DialogTypes.saveConfiguration
		};
		showDialog(dialogProps);
	};

	return {
		warnBeforeExit,
		saveConfiguration
	};
}

// keep the following for setups

// function createSetupProps(
// 	{
// 		showDialog,
// 		removeAllParts,
// 		applyParts,
// 		setups,
// 		selectedSetup: selected,
// 		appliedSetup: applied,
// 		selectSetup: selectSetupDispatcher,
// 		applySetup: applySetupDispatcher
// 	}
// 		: ConfigurationAllProps) {

// 	// setup parts dialog
// 	const openDetail = (setup: Setup) => {
// 		const dialogProps: ShowDialogProps = {
// 			title: `${setup.Name} parts`,
// 			data: setup.PartIds,
// 			contentType: DialogTypes.setupParts,
// 		};
// 		showDialog(dialogProps);
// 	};

// 	const selectSetup = (setup: Setup) => {
// 		selectSetupDispatcher(setup);
// 	};

// 	const applySetup = (setup: Setup) => {
// 		applySetupDispatcher(setup);
// 		// scrap all previous parts on setup change
// 		removeAllParts();
// 		applyParts(setup.PartIds);
// 	};

// 	const setuplistProps: SetuplListProps = {
// 		setups,
// 		openDetail,
// 		selectSetup,
// 		selected,
// 		applied,
// 		applySetup
// 	};

// 	return setuplistProps;
// }
